var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGhs07 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "SUNDHEDSFARE 07",
  viewBox: "0 0 566 566",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m25.78 290.94 263.67 263.67 263.77-263.67Q421.39 159.09 289.55 27.26L25.78 290.94",
  style: {
    fill: "#fff"
  },
  transform: "translate(-6.5 -7.88)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.5 290.94 283 283 283.05-283-283-283.06Zm521.16 0-238.21 238-238-238.1 238.1-238.11 238.11 238.11",
  style: {
    fill: "red"
  },
  transform: "translate(-6.5 -7.88)"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M282.85 136.34h-2a47.4 47.4 0 0 0-30.06 12.08 22.81 22.81 0 0 0-6.39 11.29 10.29 10.29 0 0 0-.3 3.49 12 12 0 0 0 .3 3.7c.2 1.4 19.47 131.24 19.67 133.43a21.1 21.1 0 0 0 41.85 0c.3-2.69 19.48-132.23 19.78-133.53a16.77 16.77 0 0 0 .2-3.5 13 13 0 0 0-.5-4.69 23.36 23.36 0 0 0-10.59-13.78 49.43 49.43 0 0 0-29.06-8.49h-2.9Zm2 200.85h-1.2a30.16 30.16 0 0 0-24.27 14.08 33.7 33.7 0 0 0-5.49 23.17 34.23 34.23 0 0 0 11.38 21.78 31 31 0 0 0 19.88 7.39 31.57 31.57 0 0 0 25.77-14.09 34.08 34.08 0 0 0 5.39-23.4 38.92 38.92 0 0 0-3.2-11 31.66 31.66 0 0 0-28.06-18"
})));
export default SvgGhs07;